<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 43.55 43.55"
    @click="$emit('click', $event)"
  >
    <path
      class="cls-1"
      d="M43.08,40.82l-13.03-13.04c2.43-2.94,3.9-6.71,3.9-10.81C33.95,7.61,26.33,0,16.97,0S0,7.61,0,16.97s7.61,16.97,16.97,16.97c4.1,0,7.87-1.47,10.81-3.9l13.03,13.03c.31.31.72.47,1.13.47s.82-.16,1.13-.47c.62-.62.62-1.64,0-2.26ZM3.2,16.97c0-7.59,6.18-13.77,13.78-13.77s13.77,6.18,13.77,13.77-6.18,13.77-13.77,13.77S3.2,24.57,3.2,16.97Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  },
  emits: ['click']
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
  cursor: pointer;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
